import Field from 'cerebral-module-forms/Field'
import createAggregationField from '../helpers/createAggregationField'

export default function prepareAggregationFields({ state }) {
  let aggregations = state.get('client.aggregations')
  if (aggregations) {
    aggregations.forEach(aggregation => {
      state.set(
        `client.registrating.current.common.${aggregation.key}`,
        Field(createAggregationField(aggregation))
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/actions/prepareAggregationFields.js